import { IExportColumnModel } from "../../../../../shared/models";

export const ExtractionSchedulingRecipesChangesColumnList: IExportColumnModel[] = [
]